<template>
  <div class="official-assoc">
    <div class="off-event-box">
      <img :src="bgImg.seq1">
      <img :src="bgImg.seq2">
      <img :src="bgImg.seq3">
      <img :src="bgImg.seq4">
      <img :src="bgImg.seq5">
      <img :src="bgImg.seq6">
      <img :src="bgImg.seq7">
      <img :src="bgImg.seq8">
      <img :src="bgImg.seq9">
    </div>
    <div class="off-footer-box display-flex-end">
      <div v-if="false" class="off-btn-item pop"><div>联系顾问</div></div>
      <div class="off-btn-item yellow" @click="goTrial"><div>我想试用</div></div>
    </div>
  </div>
</template>

<script>
import { getAppPath, varConfig, ImageFormat } from '@/utils'

export default {
  name: 'officialAthleticAssociation',
  data() {
    return {
      bgImg: {}
    }
  },
  created() {

  },
  mounted() {
    this.shareData = {
      title: '邦协会・专注体育协会数字化',
      abstract: '聚焦体育协会 会员注册审核 活动报名收费',
      link: this.getShareLink(),
      image: ImageFormat.squareImageView('Fq8JjinKjo3oZsIpOTV5zvHB2oM_', 120)
    }
    this.wxShare(this.shareData)
    const bgImg = {}
    bgImg.seq1 = ImageFormat.squareImageView('Fne5X1A9gfvl7I7hA7Tz74lsd2Ub', 0)
    bgImg.seq2 = ImageFormat.squareImageView('FgtP3uZYUaNNQK2dacrZBh3JKs4g', 0)
    bgImg.seq3 = ImageFormat.squareImageView('FkuE1zX5g5azgXXAOVy3DWDk0Y5h', 0)
    bgImg.seq4 = ImageFormat.squareImageView('Fpa6QQa0DeT-2swCMZoXYHE8h3zr', 0)
    bgImg.seq5 = ImageFormat.squareImageView('Fj7_hT6J3yEQQcsr7ncGk9IKMQUR', 0)
    bgImg.seq6 = ImageFormat.squareImageView('Fi8uDvSv8x3lHM1SiojD9rgUKR3x', 0)
    this.bgImg = bgImg
  },
  methods: {
    goTrial() {
      const path = getAppPath('webapplt')
      const url = `${varConfig.siteUrl}/${path}/index/index.html#/reservation?type=3&radio=体育协会&result=协会系统`
      window.location.href = url
    },
    getShareLink: function () {
      const arr = window.location.href.split('index.html')
      return arr[0] + 'index.html#/official-athleticAssociation?v=1'
    }
  }
}
</script>

<style lang="scss">
  .official-assoc {
    .off-event-box{
      width: 100%;
      position: relative;
      padding-bottom: 51px;
      img{
        width: 100%;
        height: 100%;
        position: relative;
        top: 0;
        left: 0;
        display: block;
      }
    }
    .off-footer-box{
      position: fixed;
      bottom: 0;
      width: 100%;
      max-width: 480px;
      height: 50px;
      background: rgba(255, 255, 255, 0.8);
      padding: 4px 0;
      .off-btn-item{
        display: inline-block;
        padding: 4px 17px;
        border-radius: 24px;
        color: #FFFFFF;
        cursor: pointer;
      }
      .pop{
        background: linear-gradient(180deg, #B292E4 0%, #7B5BAA 100%);
        margin-right: 15px;
      }
      .yellow{
        background: linear-gradient(180deg, #F08977 0%, #FF2D13 100%);
        margin-right: 38px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/official-athleticAssociation/index.vue